import { Col, Container, Nav, Row, Tab } from "@themesberg/react-bootstrap";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import CustomerWiseCalibration from "./CustomerWiseCalibration";
import CustomerWiseFieldVisit from "./CustomerWiseFieldVisit";
import CustomerWiseInstallation from "./CustomerWiseInstallation";
import DealerWiseCalibration from "./DealerWiseCalibration";
import DealerWiseFieldVisit from "./DealerWiseFieldVisit";
import DealerWiseInstallation from "./DealerWiseInstallation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ServiceEngWiseCalibration from "./ServiceEngWiseCalibration";
import ServiceEngWiseFieldVisit from "./ServiceEngWiseFieldVisit";
import ServiceEngWiseInstallation from "./ServiceEngWiseInstallation";
import WorkOrderCalibrationReport from "./WorkOrderCalibrationReport";
import WorkOrderFieldVisitReport from "./WorkOrderFieldVisitReport";
import WorkOrderInstallationReport from "./WorkOrderInstallationReport";
import { faUser } from "@fortawesome/free-regular-svg-icons";

export default () => {
  const [role, setRole] = useState(sessionStorage.getItem("role"));
  const [selectValue, setSelectValue] = React.useState("");

  const onChange = (event) => {
    const value = event.target.value;
    setSelectValue(value);
  };
  return (
    <article>
      <Container className="px-0">
        <Row className="d-flex flex-wrap flex-md-nowrap align-items-center py-4">
          <Col className="d-block mb-4 mb-md-0">
            <h5 className="head mb-4">Work Order Reports View</h5>
          </Col>
        </Row>
        <div>
          <Tab.Container defaultActiveKey="installationReport">
            <Row>
              <Col lg={12}>
                <Nav fill variant="pills" className="flex-column flex-sm-row">
                  <Nav.Item>
                    <Nav.Link
                      eventKey="installationReport"
                      className="mb-sm-3 mb-md-0"
                    >
                      <FontAwesomeIcon icon={faUser} className="me-2" />{" "}
                      Installation Report
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      eventKey="calibration"
                      className="mb-sm-3 mb-md-0"
                    >
                      <FontAwesomeIcon icon={faUser} className="me-2" />
                      Calibration Report
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="fieldVisit" className="mb-sm-3 mb-md-0">
                      <FontAwesomeIcon icon={faUser} className="me-2" />
                      Field Job Report
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </Col>
              <Col lg={12}>
                <Tab.Content>
                  <Tab.Pane eventKey="installationReport" className="py-2">
                    {role == "admin" || role == "customer" ? (
                      <>
                        <WorkOrderInstallationReport />
                      </>
                    ) : (
                      ""
                    )}
                     {/* <hr /> */}
                    <Row> 
                    {/* <Col md={4} className="mb-3">
                      <input
                        type="radio"
                        value="CustomerWiseInstallation"
                        checked={selectValue === "CustomerWiseInstallation"}
                        onChange={onChange}
                      />
                      <span className="radioBtn">Customer Wise Installation Report</span>
                      </Col>
                      <Col md={4} className="mb-3">
                      <input
                        type="radio"
                        value="DealerWiseInstallation"
                        checked={selectValue === "DealerWiseInstallation"}
                        onChange={onChange} 
                      />
                      <span className="radioBtn">Dealer Wise Installation Report</span>
                    </Col>
                    <Col md={4} className="mb-3">
                      <input
                        type="radio"
                        value="ServiceEngWiseInstallation"
                        checked={selectValue === "ServiceEngWiseInstallation"}
                        onChange={onChange}
                      />
                      <span className="radioBtn">Service Engineer Wise Installation Report</span>
                    </Col> */}
                    </Row>
                    <br />
                    {selectValue === "DealerWiseInstallation" ? (
                      <>
                     
                        {" "}
                        {role == "admin" ? <DealerWiseInstallation />:""}
                      </>
                    ) : selectValue === "ServiceEngWiseInstallation" ? (
                      <>
                        {role == "admin" ?   <ServiceEngWiseInstallation />:""}
                      </>
                    ) : (
                      <>
                          {role == "admin" ? <CustomerWiseInstallation />:""}
                      </>
                      
                    )}
                  </Tab.Pane>
                </Tab.Content>
              </Col>
              <Col lg={12}>
                <Tab.Content eventKey="calibration">
                  <Tab.Pane eventKey="calibration" className="py-4">
                  {role == "admin" || role == "customer" ? (
                      <>
                        <WorkOrderCalibrationReport />
                      </>
                    ) : (
                      ""
                    )}
                    {/* <hr /> */}
                    <Row> 
                    {/* <Col md={4} className="mb-3">
                      <input
                        type="radio"
                        value="CustomerWiseCalibration"
                        checked={selectValue === "CustomerWiseCalibration"}
                        onChange={onChange}
                       
                      />
                      <span className="radioBtn">Customer Wise Calibration Report</span>
                      </Col>
                      <Col md={4} className="mb-3">
                      <input
                        type="radio"
                        value="DealerWiseCalibration"
                        checked={selectValue === "DealerWiseCalibration"}
                        onChange={onChange}
                       
                      />
                      <span className="radioBtn">Dealer Wise Calibration Report</span>
                    </Col>
                    <Col md={4} className="mb-3">
                      <input
                        type="radio"
                        value="ServiceEngWiseCalibration"
                        checked={selectValue === "ServiceEngWiseCalibration"}
                        onChange={onChange}
                      />
                      <span className="radioBtn">Service Engineer Wise Calibration Report</span>
                    </Col> */}
                    </Row>
                    {/* <hr /> */}
                    <br />
                    {selectValue === "DealerWiseCalibration" ? (
                      <>
                        {" "}
                        {role == "admin" ?<DealerWiseCalibration /> :""}
                      </>
                    ) : selectValue === "ServiceEngWiseCalibration" ? (
                      <>
                          {role == "admin" ? <ServiceEngWiseCalibration />:""}
                      </>
                    ) : (
                      <>
                          {role == "admin" ? <CustomerWiseCalibration />:""}
                      </>
                    )}
                  </Tab.Pane>
                </Tab.Content>
              </Col>
              <Col lg={12}>
                <Tab.Content eventKey="fieldVisit">
                  <Tab.Pane eventKey="fieldVisit" className="py-4">
                  {role == "admin" || role == "customer" ? (
                      <>
                        <WorkOrderFieldVisitReport />
                      </>
                    ) : (
                      ""
                    )}
                   {/* <hr /> */}
                    <Row> 
                    {/* <Col md={4} className="mb-3">
                      <input
                        type="radio"
                        value="CustomerWiseFieldVisit"
                        checked={selectValue === "CustomerWiseFieldVisit"}
                        onChange={onChange}
                       
                      />
                      <span className="radioBtn">Customer Wise Field Job Report</span>
                      </Col>
                      <Col md={4} className="mb-3">
                      <input
                        type="radio"
                        value="DealerWiseFieldVisit"
                        checked={selectValue === "DealerWiseFieldVisit"}
                        onChange={onChange}
                       
                      />
                      <span className="radioBtn">Dealer Wise Field Job Report</span>
                    </Col>
                    <Col md={4} className="mb-3">
                      <input
                        type="radio"
                        value="ServiceEngWiseFieldVisit"
                        checked={selectValue === "ServiceEngWiseFieldVisit"}
                        onChange={onChange}
                      />
                      <span className="radioBtn">Service Engineer Wise Field Job Report</span>
                    </Col> */}
                    </Row>
                    <br />
                    
                    {selectValue === "DealerWiseFieldVisit" ? (
                      <>
                     
                        {role == "admin" ?   <DealerWiseFieldVisit />:""}
                      </>
                    ) : selectValue === "ServiceEngWiseFieldVisit" ? (
                      <>
                        {role == "admin" ?   <ServiceEngWiseFieldVisit />:""}
                      </>
                    ) : (
                      <>
                         {role == "admin" ?  <CustomerWiseFieldVisit />:""}
                      </>
                    )}
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </div>
      </Container>
    </article>
  );
};
